import {
  SET_AI_CHAT_FEATURE_FLAG,
  SET_AI_ENABLED_FEATURE_FLAG,
  SET_AI_INTAKE_REPORT_FEATURE_FLAG,
  SET_FEATURE_FLAGS,
  SET_TWA_MASTER_AI_CONSENT_FEATURE_FLAG,
  SET_AI_CHAT_FEATURE_FLAG_VERSION,
  SET_AI_OFFLINE_RECORDING_FEATURE_FLAG,
} from "../Actions/types";

const initialState = {
  features: [
    {
      name: "twa_private_google_calender_auth",
      enabled: true,
    },
    {
      name: "twa_private_session_listing_dashboard",
      enabled: true,
    },
    {
      name: "twa_private_session_listing_clients",
      enabled: true,
    },
    {
      name: "twa_private_notes_listing_clients",
      enabled: true,
    },
    {
      name: "twa_private_tools_listing_clients",
      enabled: true,
    },
    {
      name: "twa_private_mgaf_listing_clients",
      enabled: true,
    },
    {
      name: "twa_private_cgi_listing_clients",
      enabled: true,
    },
    {
      name: "twa_private_documents_listing_clients",
      enabled: true,
    },
    {
      name: "twa_private_chat_clients",
      enabled: true,
    },
    {
      name: "twa_private_analytics",
      enabled: true,
    },
    {
      name: "twa_private_availability",
      enabled: true,
    },
    {
      name: "twa_private_supervision",
      enabled: true,
    },
    {
      name: "twa_private_notifications",
      enabled: true,
    },
  ],
  ai_chat_feature: false,
  ai_enabled: false,
  twa_master_ai_consent: false,
  ai_intake_report_enabled: false,
  ai_offline_recording_enabled: false,
  ai_chat_feature_version: "v2",
};

const featureFlagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURE_FLAGS:
      return { ...state, features: action.payload || initialState.features };
    case SET_AI_CHAT_FEATURE_FLAG:
      return { ...state, ai_chat_feature: action.payload };
    case SET_TWA_MASTER_AI_CONSENT_FEATURE_FLAG:
      return { ...state, twa_master_ai_consent: action.payload };
    case SET_AI_ENABLED_FEATURE_FLAG:
      return { ...state, ai_enabled: action.payload };
    case SET_AI_INTAKE_REPORT_FEATURE_FLAG:
      return { ...state, ai_intake_report_enabled: action.payload };
    case SET_AI_OFFLINE_RECORDING_FEATURE_FLAG:
      return { ...state, ai_offline_recording_enabled: action.payload };
    case SET_AI_CHAT_FEATURE_FLAG_VERSION:
      return { ...state, ai_chat_feature_version: action.payload };
    default:
      return state;
  }
};

export default featureFlagsReducer;
